import React from 'react'

import { Subsection } from '@fourthwall/components'
import { pluralize } from '@fourthwall/utils/dist/string'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import * as S from './ReadOnlyPollFields.styled'

type Props = {
  pollFinishDate: string
  pollOptions: { title: string; votes: { percentage: number; amount: number } }[]
  votesAmount: number
}

export const ReadOnlyPollFields = ({ pollFinishDate, pollOptions, votesAmount }: Props) => (
  <Subsection title="Poll options">
    <S.OptionsContainer>
      {pollOptions.map(({ title, votes }, index) => (
        <S.Option key={index}>
          <S.Title>{title}</S.Title>
          <S.PercentageBar percentage={votes.percentage} />
          <S.PercentageContainer>
            <S.VotesAmount>
              {votes.amount} {pluralize(votes.amount, 'vote', 'votes')}
            </S.VotesAmount>
            {`${votes.percentage.toFixed(0)} %`}
          </S.PercentageContainer>
        </S.Option>
      ))}
    </S.OptionsContainer>
    <S.Divider />
    <S.Info>
      <span>
        {votesAmount} {pluralize(votesAmount, 'vote', 'votes')}
      </span>
      <span>
        Finish date:{' '}
        <TimezonedDateString
          date={pollFinishDate}
          format="MMMM D, h:mm"
          withTimezoneAbbreviation={false}
        />
      </span>
    </S.Info>
  </Subsection>
)
